import React, { useEffect } from "react";
import "@/App.css";
import "@/i18n";
import { useTranslation } from "react-i18next";
import { isRTL } from "@/i18n";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Metoden from "./components/Metoden";
import Biologisk from "./components/Biologisk";
import Banen from "./components/Banen";
import EffektOverTid from "./components/EffektOverTid";
import FutureFootball from "./components/FutureFootball";
import MidCTA from "./components/MidCTA";
import CoachD from "./components/CoachD";
import Historien from "./components/Historien";
import Udtalelser from "./components/Udtalelser";
import Videnskab from "./components/Videnskab";
import MissionVision from "./components/MissionVision";
import Kontakt from "./components/Kontakt";
import Footer from "./components/Footer";
import EnergyDivider from "./components/decor/EnergyDivider";
import ScrollProgress from "./components/ScrollProgress";

function App() {
  const { i18n, t } = useTranslation();

  // Sync <html lang>, <html dir>, <title> and <meta description> with current locale.
  useEffect(() => {
    const lang = i18n.resolvedLanguage || "da";
    document.documentElement.lang = lang;
    document.documentElement.dir = isRTL(lang) ? "rtl" : "ltr";

    const title = t("meta.title");
    if (title && !title.startsWith("meta.")) {
      document.title = title;
    }

    const desc = t("meta.description");
    const descEl = document.querySelector('meta[name="description"]');
    if (descEl && desc && !desc.startsWith("meta.")) {
      descEl.setAttribute("content", desc);
    }

    // Update OG/Twitter for shareability
    const og = document.querySelector('meta[property="og:title"]');
    if (og && title && !title.startsWith("meta.")) og.setAttribute("content", title);
    const ogd = document.querySelector('meta[property="og:description"]');
    if (ogd && desc && !desc.startsWith("meta.")) ogd.setAttribute("content", desc);
    const tw = document.querySelector('meta[name="twitter:title"]');
    if (tw && title && !title.startsWith("meta.")) tw.setAttribute("content", title);
    const twd = document.querySelector('meta[name="twitter:description"]');
    if (twd && desc && !desc.startsWith("meta.")) twd.setAttribute("content", desc);
  }, [i18n.resolvedLanguage, t]);

  return (
    <div className="App relative min-h-screen bg-[#05020E] text-white antialiased">
      <ScrollProgress />
      <Navbar />
      <main>
        <Hero />
        <Metoden />
        <EnergyDivider color="#FF3DCB" />
        <Biologisk />
        <Banen />
        <EnergyDivider flip color="#3DBFFF" />
        <EffektOverTid />
        <FutureFootball />
        <MidCTA />
        <EnergyDivider color="#FF2D5C" />
        <CoachD />
        <Historien />
        <Udtalelser />
        <EnergyDivider flip color="#9B4DFF" />
        <Videnskab />
        <MissionVision />
        <Kontakt />
      </main>
      <Footer />
    </div>
  );
}

export default App;
